import {
  EmailValidationSendResponse,
  EmailValidationCheckResponse,
  LoginResponse,
  LogoutResponse,
  NewPasswordResponse,
  ResetPasswordResponse,
  InvitationResponse,
  InvitationLinkResponse,
} from "../types/axios.types";
import { client } from "../client";

// Request an authentication token with credentials
export const login = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  const response = await client.post<LoginResponse>("/auth/login", {
    email,
    password,
  });
  return response.data;
};

export const invitation = async ({
  token,
  firstName,
  lastName,
  role,
  password,
  phoneNumber,
}: {
  token: string;
  firstName: string;
  lastName: string;
  role: string;
  password: string;
  phoneNumber: string;
}) => {
  const response = await client.post<InvitationResponse>("/auth/invitation", {
    token,
    firstName,
    lastName,
    role,
    password,
    phoneNumber,
  });
  return response.data;
};

export const invitationLink = async ({
  token,
  email,
  password,
}: {
  token: string;
  email: string;
  password: string;
}) => {
  const response = await client.post<InvitationLinkResponse>("/auth/invitation/link", {
    token,
    password,
    email,
  });
  return response.data;
};

export const logout = async () => {
  const response = await client.post<LogoutResponse>("/auth/logout");
  return response.data;
};

export const resetPassword = async ({ email }: { email: string }) => {
  const response = await client.post<ResetPasswordResponse>(
    "/auth/password/reset",
    {
      email: email,
    }
  );
  return response.data;
};

export const newPassword = async ({
  password,
  token,
}: {
  password: string;
  token: string;
}) => {
  const response = await client.post<NewPasswordResponse>(
    "/auth/password/new",
    {
      password,
      token,
    }
  );
  return response.data;
};

export const emailValidationSend = async ({ email }: { email: string }) => {
  const response = await client.post<EmailValidationSendResponse>(
    "/auth/signin/validation/send",
    {
      email,
    }
  );
  return response.data;
};

export const emailValidationCheck = async ({
  email,
  code,
}: {
  email: string;
  code: string;
}) => {
  const response = await client.post<EmailValidationCheckResponse>(
    "/auth/signin/validation/check",
    {
      email,
      code,
    }
  );
  return response.data;
};
